@use '../../../scss/global/spacing';
@use '../../../scss/global/color';
@use '../../../scss/global/border.scss';
@use '../../../scss/utils/mixins.scss' as utils-mixins;

@use './toggle-switch.vars.scss' as *;
@use './toggle-switch.mixins' as mixins;

:host {
  .fds-toggle-switch__toggle-wrapper {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: spacing.$spacer-4;
    padding: spacing.$spacer-3 spacing.$spacer-4;
    border-width: 1px;
    border-style: solid;
    border-color: color.$default-transparent;
    border-radius: border.$radius-1;
    user-select: none;

    input {
      @include utils-mixins.visually-hidden;
    }
  }

  @include mixins.toggle-switch-text;

  .fds-toggle-switch {
    &__switch {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      border-radius: 50px; /* TODO: Missing this border radius in tokens  */
      width: var(--toggle-switch-width);
      height: var(--toggle-switch-height);
      background-color: var(--switch-background-color);
      padding: 4px;
      align-items: center;
      gap: 4px;
    }

    &__switch-knob {
      position: var(--knob-position);
      align-items: center;
      display: flex;
      justify-content: center;
      width: var(--toggle-knob-width);
      height: var(--toggle-knob-height);
      border-radius: 50%;
      box-sizing: border-box;
      transition:
        left 0.1s ease-out,
        border 0.1s ease-out;
      background-color: var(--knob-color);
      padding: 4px;
      gap: 8px;
      flex-shrink: 0;
    }
  }
}

@include mixins.toggle-switch-focus;
@include mixins.toggle-switch-hover;
@include mixins.toggle-switch-disabled;

:host(.fds-toggle-switch--framed) {
  .fds-toggle-switch__toggle-wrapper {
    border-color: var(--frame-color-default);
    background-color: var(--frame-background-color);
  }
}

:host(.fds-toggle-switch--full-width) {
  .fds-toggle-switch__toggle-wrapper {
    display: flex;
  }
}

:host(.fds-toggle-switch--checked) {
  .fds-toggle-switch {
    &__switch {
      background-color: var(--switch-background-color-toggled);
    }

    &__switch-knob {
      left: calc(100% - 24px);
      background-color: var(--knob-color-toggled);
      color: var(--icon-color);
    }
  }
}

.fds-toggle-switch__description {
  color: var(--description-color);
}

.mode-switchIcon--checked {
  display: var(--icon-mode-switch);
  color: var(--fds-color-common-black10, #{color.$default-black-10});
}

.mode-switchIcon {
  display: var(--icon-mode-switch);
  color: var(--fds-color-common-white100, #{color.$default-white-100});
  margin-left: auto;
  margin-right: 0;
}

.toggle-switchIcon {
  display: var(--icon-toggle-switch);
}
